import { Workflow } from 'lucide-react'
import { useState } from 'react'

import { type PostBrokersTaskWorkflowsWorkflowType } from 'utils/web_api.schemas'

import ComboboxMultiSelectFilter from '../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../types'

// Type-safe workflow type labels
export const WORKFLOW_TYPE_LABELS: Record<PostBrokersTaskWorkflowsWorkflowType, string> = {
  submission: 'Submission',
  renewal: 'Renewal',
  plan_change: 'Plan Change',
  dependent_change: 'Dependent Change',
  plan_change_and_dependent_change: 'Plan Change & Dependent Change',
  off_thatch: 'Off Thatch',
  cancellation: 'Cancellation',
  offboarding: 'Offboarding',
  medicare: 'Medicare',
}

// Convert to options format
export const WORKFLOW_TYPE_OPTIONS = Object.entries(WORKFLOW_TYPE_LABELS).map(
  ([value, label]) => ({
    value: value as PostBrokersTaskWorkflowsWorkflowType,
    label,
  })
)

const WorkflowsTypeFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredOptions = WORKFLOW_TYPE_OPTIONS?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Type', options: filteredOptions || [] }]}
        placeholder='Search workflow types to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={WORKFLOW_TYPE_OPTIONS || []}
          noSelectionText='Workflow Type'
          pluralIdentifier='workflow types'
        >
          <Workflow size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default WorkflowsTypeFilter
